<!-- <p>edit-hierarchy-asset works!</p> -->
<app-dialog-header headerText="Modify Asset" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<mat-form-field>
			<mat-label>Code/Alias (Diaplay Name):</mat-label>
			<input matInput autocomplete="off" formControlName="Name" required>
			<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">Name is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Name:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">Description is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Parent Functional Location:</mat-label>
			<input matInput autocomplete="off" readonly="" formControlName="ParentFunctionalLocation" placeholder="parent location">			
		</mat-form-field>		
		<mat-form-field>
			<mat-label>Functional Location:</mat-label>
			<input matInput autocomplete="off" formControlName="FunctionalLocation" placeholder="Inherited from parent location if left empty">			
		</mat-form-field>
		<mat-form-field>
			<mat-label>Equipment Code:</mat-label>
			<input matInput autocomplete="off" formControlName="EquipmentCode">
		</mat-form-field>		

		<app-image-container [imgURL]="imageSrc" [enablePicture]="enablePicture" [enableCamera]="enableCamera"
			[enableDelete]="enableDelete" (onDelete)="deleteImg()"
			(onNewImage)="onNewImage($event)"></app-image-container>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Watch List</mat-label>
				<mat-slide-toggle #switchAdmin formControlName="Watch" color="primary"></mat-slide-toggle>
			</div>
		</div>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Display Asset Tile</mat-label>
				<mat-slide-toggle #switchAdmin formControlName="DisplayOnImage" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>